export const useStore = () => {
	let store = useState('store', () => {
		return {
			user: {
				_id: ''
			},
            drmJobs: [],
            dashJobs: [],
            hlsJobs: [],
            downloadJobs: [],
            chunkedJobs: [],
            nativeJobs: [],
		}
	})
	return store.value
}
